import { cn } from '@/lib/utils.js';

function SkeletonCard({ id }: { id: string }) {
  return (
    <div
      key={id}
      className="rounded-[var(--radius-card)] border border-[var(--color-qup-border-dark)] bg-[var(--color-qup-bg-card-dark)] p-5 shadow-[var(--shadow-card)]"
    >
      <div className="mb-3 flex items-start justify-between gap-2">
        <div className="h-5 w-3/4 animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
        <div className="h-7 w-7 animate-pulse rounded-full bg-[var(--color-qup-border-dark)]" />
      </div>
      <div className="mb-4 flex gap-2">
        <div className="h-5 w-16 animate-pulse rounded-full bg-[var(--color-qup-border-dark)]" />
        <div className="h-5 w-20 animate-pulse rounded-full bg-[var(--color-qup-border-dark)]" />
      </div>
      <div className="space-y-2">
        <div className="h-4 w-full animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-[var(--color-qup-border-dark)]" />
      </div>
    </div>
  );
}

interface CatalogSkeletonProps {
  count?: number;
  className?: string;
}

export function CatalogSkeleton({ count = 12, className }: CatalogSkeletonProps) {
  const ids = Array.from({ length: count }, (_, i) => `skeleton-${i}`);

  return (
    <output
      aria-label="Cargando el catálogo…"
      aria-busy="true"
      className={cn('grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3', className)}
    >
      {ids.map((id) => (
        <SkeletonCard key={id} id={id} />
      ))}
    </output>
  );
}
